<template>
  <div>
    <OTextField
      class="pa-6 w-300"
      placeholder="Filtrar..."
      v-model="keywords"
      clearable
    />
    <ODataGrid class="dense-table" :data="gridData" :order.sync="order" />
  </div>
</template>

<script>
import ODataGrid from 'oderon-vue/cpts/ODataGrid.vue'
import { preProcessSpec } from 'oderon-commons/src/tables'
import grid from 'oderon-commons/src/grid'
import utils from 'oderon-commons/src/utils.js'
import fmt from 'oderon-commons/src/formatters'

const spec = preProcessSpec({
  defaultSortable: true,
  columns: [
    { t: 'Key', d: 'key' },
    {
      t: 'Value|',
      d: (row) => {
        let x = row.value
        if (x == null) return null
        if (typeof x === 'object') x = utils.atMost(JSON.stringify(x), 40)
        return x
      }
    },
    { t: 'Updated at|', d: 'updatedAt', f: fmt.brDateTime, w: 180 },
    { t: 'Updated by|', d: 'updatedBy', w: 150 }
  ]
})

export default {
  components: {
    ODataGrid
  },
  props: {
    allConfigs: { required: true }
  },
  data() {
    return {
      keywords: null,
      order: 'key asc'
    }
  },
  computed: {
    filteredRows() {
      let result = this.allConfigs.map((x, idx) => {
        return { id: idx, ...x }
      })

      result = result.filter((x) =>
        utils.matchAnyLike(this.keywords, x.key, x.value)
      )

      return utils.orderBy(result, this.order)
    },
    gridData() {
      return grid.generateWebGrid({
        rows: this.filteredRows,
        spec
      })
    }
  }
}
</script>

<style></style>
